module.exports = __webpack_public_path__ + "img/Playstore_Button.6d36d60d.svg";